import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultIcon',
  props: {
	icon: String
},
  setup(__props) {

const props = __props;

// eslint-disable-next-line




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["codicon", __props.icon])
  }, null, 2))
}
}

})